"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDate = void 0;
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const Col_1 = require("@amzn/atoz-web/Col");
const DatePickerView_1 = require("../../../../components/DatePickerView");
const PunchSection_1 = require("../../../../components/PunchSection");
const logger_1 = require("../../../../logger");
const BIAnalytics_1 = __importDefault(require("../../../../utils/BIAnalytics/BIAnalytics"));
const SelectDateTypes_1 = require("./SelectDateTypes");
const useSelectDate_1 = require("./hooks/useSelectDate");
const context_1 = require("../../context");
const SelectDate = () => {
    const { featureGates, associateInfo, selectedDateTime, selectedPunchList, punchesForMealLockoutValdn } = (0, context_1.usePunchWorkflowContext)();
    const { isLoading, daysWithShifts, daysWithPayDays, daysWithPunches, daysWithAttention, punchCorrStatusList, updateDateAction } = (0, useSelectDate_1.useSelectDate)({ isWeb: true });
    (0, react_1.useEffect)(() => {
        BIAnalytics_1.default.arriveSelectDateInPW();
    }, []);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_WORKFLOW_SELECT_DATE_STEP_RENDERED.COUNT
        },
        isComponentLoaded: !isLoading
    });
    return (react_1.default.createElement(Col_1.Col, { dataTestId: SelectDateTypes_1.SELECT_DATE_DATA_TEST_IDS.SELECT_DATE },
        react_1.default.createElement(DatePickerView_1.DatePickerView, { locale: associateInfo.locale, isLoading: isLoading, daysWithShifts: daysWithShifts, daysWithPayDays: daysWithPayDays, daysWithPunches: daysWithPunches, daysWithAttention: daysWithAttention, maxDate: luxon_1.DateTime.now(), selectedDate: selectedDateTime, updateDateAction: updateDateAction }),
        react_1.default.createElement(PunchSection_1.PunchSection, { isDataLoading: isLoading, associateInfo: associateInfo, selectedDate: selectedDateTime, militaryTime: false, punchWithTimespans: selectedPunchList, punchesForMealLockoutValdn: punchesForMealLockoutValdn, punchCorrStatusList: punchCorrStatusList, featureGates: featureGates, useUnifiedPunchesAPIForWeb: true, hasUnverifiedMissedPunchLimit: true, readOnly: true })));
};
exports.SelectDate = SelectDate;
